export default __webpack_public_path__ + "static/media/geography.4de3659c.svg";